export const environment = {
  production: false,
  name: "dev environment",
  endPoint:"https://quovo-develop-gna8dugjheffg6cs.italynorth-01.azurewebsites.net/api/"
};
